import ListItem from "../../shared/ListItem/ListItem";
import UnorderedList from "./UnorderedList";
var Ul = UnorderedList;
Ul.Li = ListItem;
export default Ul;